export const INBOX_READ_TIMESTAMPS = 'inboxReadTimestamps';
export const HIDDEN_INBOX_TRANSACTION_IDS = 'hiddenInboxTransactionIds';

const validDateValue = value => {
  const timestamp = value ? new Date(value).getTime() : NaN;
  return Number.isFinite(timestamp) ? timestamp : null;
};

export const getInboxReadTimestamps = currentUser => {
  const value = currentUser?.attributes?.profile?.privateData?.[INBOX_READ_TIMESTAMPS];
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
};

export const getHiddenInboxTransactionIds = currentUser => {
  const value = currentUser?.attributes?.profile?.privateData?.[HIDDEN_INBOX_TRANSACTION_IDS];
  return Array.isArray(value) ? [...new Set(value.filter(id => typeof id === 'string'))] : [];
};

export const getLatestIncomingMessage = (messages, currentUserId) => {
  return [...(messages || [])]
    .filter(message => message?.sender?.id?.uuid && message.sender.id.uuid !== currentUserId)
    .sort((a, b) => b.attributes.createdAt - a.attributes.createdAt)[0];
};

export const isConversationUnread = ({ transactionId, latestIncomingMessage, readTimestamps }) => {
  const latestIncomingAt = validDateValue(latestIncomingMessage?.attributes?.createdAt);
  if (!transactionId || latestIncomingAt === null) {
    return false;
  }

  const readAt = validDateValue(readTimestamps?.[transactionId]);
  return readAt === null || latestIncomingAt > readAt;
};

export const countUnreadConversations = ({ conversations, currentUser }) => {
  const currentUserId = currentUser?.id?.uuid;
  const readTimestamps = getInboxReadTimestamps(currentUser);
  const hiddenIds = new Set(getHiddenInboxTransactionIds(currentUser));

  return (conversations || []).reduce(
    (counts, { transaction, messages }) => {
      const transactionId = transaction?.id?.uuid;
      if (!transactionId || hiddenIds.has(transactionId)) {
        return counts;
      }

      const latestIncomingMessage = getLatestIncomingMessage(messages, currentUserId);
      if (!isConversationUnread({ transactionId, latestIncomingMessage, readTimestamps })) {
        return counts;
      }

      const isOrder = transaction?.customer?.id?.uuid === currentUserId;
      return isOrder
        ? { ...counts, orderNotificationsCount: counts.orderNotificationsCount + 1 }
        : { ...counts, saleNotificationsCount: counts.saleNotificationsCount + 1 };
    },
    { saleNotificationsCount: 0, orderNotificationsCount: 0 }
  );
};
